import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from '../_services';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from 'src/shared/globals';
import { FormsModule } from '@angular/forms';
import { EventEmitterService } from '../../global_services/event-emitter.service';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';
import { ToasterService } from '../_services/toaster.service';
import { Title } from '@angular/platform-browser';
import { LoaderService } from '../_services/loader.service';
import { NiceScrollService } from '../_services/nice-scroll.service';

@Component({
    selector: 'app-login-register',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {

  model: any = {};
  rememberme = false;
  previousUrl: string;
  constructor(
    private router: Router,
    private userService: AuthenticationService,
    private eventEmitterService: EventEmitterService,
    private toastr: ToasterService,
    private title: Title,
    private loaderService: LoaderService,
    private niceScroll: NiceScrollService
    ) {
      niceScroll.scrollToTop();
    }

  ngOnInit() {
    this.title.setTitle('Login | pakmatti.com');
    // tslint:disable-next-line: variable-name
    const _localStorage = JSON.parse(localStorage.getItem('currentUser'));
    if (_localStorage) {
      this.router.navigate(['/property/submit']);
    } else {
      this.userService.logout();
    }
  }

  HeaderComponentReInitiateFunction() {
    this.eventEmitterService.ComponentManipulator();
  }

  login() {
    this.loaderService.showLoader();
    this.userService.login(this.model.username, this.model.password)
      .subscribe(user => {

        if (user.IsSuccess) {
          localStorage.setItem('currentUser', JSON.stringify(user.Data));
          this.HeaderComponentReInitiateFunction();
          this.router.navigate(['/account/properties']);
        } else {
          this.toastr.Error(user.Message);
        }
        this.loaderService.hideLoader();
      });
  }
}

